export function isMobilePhone() {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  return /android|iphone|blackberry|iemobile|opera mini/i.test(ua)
    && !/ipad|ipod/i.test(ua);
}

export function getDeviceTypeByUserAgent() {
  const userAgent = navigator.userAgent;
  if (/Mobi|Android/i.test(userAgent)) return 'mobile';
  if (/Tablet|iPad/i.test(userAgent)) return 'tablet';
  return 'desktop';
}
